var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2539_594)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2539_594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236 90H176V150H236V90ZM216 130H196V110H216V130ZM296 110V90H276V70C276 59 267 50 256 50H236V30H216V50H196V30H176V50H156C145 50 136 59 136 70V90H116V110H136V130H116V150H136V170C136 181 145 190 156 190H176V210H196V190H216V210H236V190H256C267 190 276 181 276 170V150H296V130H276V110H296ZM256 170H156V70H256V170Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2539_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2539_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white",
    transform: "translate(86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2539_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2539_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(366 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2539_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(372 16.0001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2539_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(320 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2539_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(326 16.0001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.cc982ff2c17e88248cff9fd3617f3795.svg";
export { ForwardRef as ReactComponent };